"use strict";

var _ = require("underscore");
var moment = require("moment");
var Reflux = require("reflux");

var ActivityTypeActions = require("../actions/activity-type-actions.js");

var ActivityTypeStore = Reflux.createStore({
  state: {},
  setState: function(state) {
    this.state = _.defaults(state, this.state);
    this.trigger(this.state);
    return this.state;
  },
  getInitialState: function() {
    var data = {
      instanceKey: null,
      selectedTypeId: null,
      errorMsg: null,
      metrics: [],
      types: []
    };
    return data;
  },
  init: function(){
    this.listenTo(ActivityTypeActions.selectType, this.onSelectType);
    this.listenTo(ActivityTypeActions.getActivityTypes.completed, this.onGetActivityTypesCompleted);
    this.state = this.getInitialState();
  },
  onSelectType: function(id, selected){
    _.each(this.state.types, function(type, i) {
      if(type.id==id) {
        type.selected = selected;
      }
    });
    this.trigger(this.state);
  },
  onGetActivityTypesCompleted: function(activityTypes, previouslySavedFilters){
    this.state.types = markAsSelected(activityTypes, previouslySavedFilters);
    this.trigger(this.state);

    function markAsSelected(activityTypes, previouslySavedFilters) {
      return _.map(activityTypes, function (activityType) {
        var shouldBeMarkedAsSelected = _.contains(previouslySavedFilters, activityType.id);
        if (shouldBeMarkedAsSelected) {
          activityType.selected = true;
        }
        return activityType;
      });
    }
  }
});

module.exports = ActivityTypeStore;



// WEBPACK FOOTER //
// ./app/screens/Activity/stores/activity-type-store.js